import moment from 'moment';

export const parse = dateRaw => dateRaw ? moment(dateRaw).local().valueOf() : null;

export const serialize = date => date ? moment.utc(date).toISOString() : null;

export const createEmpty = () => moment().valueOf();
